export { default } from './Tag'


// WEBPACK FOOTER //
// ./src/components/Tag/index.js